const nextStepsTextsBasicResponse = [
  {
    header: '<p>Proceso de venta</p>',
    text: `<p>Ya has completado el pedido.</p>`,
  },
  {
    header: '<p>Email de confirmación</p>',
    text: '<p>Te enviaremos un email con la confirmación de tu pedido en las próximas 48h.</p>',
  },
]

export const prepaidTexts = [
  {
    header: '<p>Portabilidad de tu número móvil</p>',
    text: `<p>Te avisaremos por SMS de la fecha y hora exactas de la portabilidad. Eso sí, el cambio lo haremos de madrugada, cuando ya tengas la SIM, para que no te quedes sin línea en el peor momento.</p>`,
  },
]

export const postpaidOnlineTexts = [
  {
    header: '<p>Entrega del pedido</p>',
    text: `<p>Recibiras tu pedido en un plazo aproximado de 2 días hábiles en el domicilio de entrega indicado.</p>
           <p>Si el alta corresponde a una portabilidad, recibiras vía SMS el avance de proceso y la confirmación de fecha la fecha y hora a la que se completará la portabilidad.</p>
           <p>Si el alta es un número nuevo se activará en un plazo máximo de 4 horas desde la entrega de tu pedido.</p>`,
  },
]

export default nextStepsTextsBasicResponse
